import SvgIcon, { type SvgIconProps } from "@mui/joy/SvgIcon"

const MainIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M8 13.65V7C8 6.44772 8.44772 6 9 6H10C10.5523 6 11 6.44772 11 7V13.65L9.5 12.25L8 13.65ZM13 15.15V3C13 2.44772 13.4477 2 14 2H15C15.5523 2 16 2.44772 16 3V12.15L13 15.15ZM3 18.6V11C3 10.4477 3.44772 10 4 10H5C5.55228 10 6 10.4477 6 11V15.6L3 18.6ZM3 21.05L9.45 14.6L13 17.65L18.6 12.05H18C17.4477 12.05 17 11.6023 17 11.05V11.05C17 10.4977 17.4477 10.05 18 10.05H21C21.5523 10.05 22 10.4977 22 11.05V14.05C22 14.6023 21.5523 15.05 21 15.05V15.05C20.4477 15.05 20 14.6023 20 14.05V13.45L13.1 20.35L9.55 17.3L5.8 21.05H3Z" />
    </SvgIcon>
  )
}

export default MainIcon
